<script>
  import { createEventDispatcher } from 'svelte';
  import { signIn } from '../utils/authSession';
  import { t } from '../i18n';
  const dispatch = createEventDispatcher();
  let busy = false;
  let error = '';
  async function login(provider) {
    if (busy) return;
    busy = true; error = '';
    try { await signIn(provider); dispatch('success'); }
    catch (e) { error = e.code === 'auth/popup-closed-by-user' ? '로그인이 취소되었습니다. 다시 시도할 수 있어요.' : e.message; }
    finally { busy = false; }
  }
</script>

<div class="login-panel">
  <img class="logo" src="/images/e_rion_logo.png" alt="E-RION" />
  <h2>{$t('login')}</h2>
  <p>{$t('loginIntro')}</p>
  <button type="button" on:click={() => login('google')} disabled={busy}>{$t('continueGoogle')}</button>
  <button type="button" on:click={() => login('apple')} disabled={busy}>{$t('continueApple')}</button>
  {#if busy}<p role="status">{$t('loggingIn')}</p>{/if}
  {#if error}<p role="alert">{error}</p>{/if}
  <small>계속하면 <a href="https://pond-echidna-ecb.notion.site/E-RION-2bf82c606e4180928714fac2b9efbded" target="_blank" rel="noreferrer">이용약관</a>과 <a href="https://pond-echidna-ecb.notion.site/E-RION-2bf82c606e4180f7b988cfced4b47013" target="_blank" rel="noreferrer">개인정보처리방침</a>을 확인할 수 있습니다.</small>
</div>
<style>
  .login-panel { display: grid; gap: 14px; text-align: center; padding: 20px; }
  .logo { width: 120px; margin: auto; } h2, p { margin: 0; } p { line-height: 1.6; }
  button { padding: 15px; background: transparent; color: inherit; border: 1px solid #aaa7; border-radius: 12px; font: inherit; cursor: pointer; }
  button:disabled { opacity: .5; cursor: wait; } [role=alert] { color: #d84c37; } small { line-height: 1.7; opacity: .8; } a { color: inherit; }
</style>
